<div class="permission-text flex-grid">
  <div class="col">
    <h4 class="section-hdr flt-left">{{ 'shared.recordPermissions' | translate }}</h4>
  </div>
  <div class="col txt-button">
    <button class="txt-button flt-right" (click)="addRecord()">{{ 'shared.addRecord' | translate }}</button>
    <mat-icon class="flt-right" svgIcon="add-icon"> </mat-icon>
  </div>
</div>

<table aria-hidden="true" cdk-table [dataSource]="recordPermissionsDataSource" class="recordpermiss-table">
  <ng-container cdkColumnDef="recordTypeVal">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.recordType' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let record">{{ record.recordTypeVal | uppercase }}</td>
  </ng-container>

  <ng-container cdkColumnDef="recordID">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.recordID' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let record">{{ record.recordID }}</td>
  </ng-container>

  <ng-container cdkColumnDef="recordDesc">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.description' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let record">{{ record.recordDesc }}</td>
  </ng-container>

  @if (pageType() !== 'user') {
    <ng-container cdkColumnDef="Approve/Reject">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.approveReject' | translate }}</th>
      <td cdk-cell *cdkCellDef="let row">
        <mat-radio-group [(ngModel)]="row.statusId">
          <mat-radio-button [value]="1">{{ 'shared.approve' | translate }}</mat-radio-button>
          <mat-radio-button [value]="2">{{ 'shared.reject' | translate }}</mat-radio-button>
        </mat-radio-group>
      </td>
    </ng-container>
  }

  <ng-container cdkColumnDef="actions">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let record">
      <button mat-icon-button (click)="deleteRecord(record.recordID)">
        <mat-icon svgIcon="del-icon"></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
</table>

@if (recordsArray?.length === 0) {
  <div class="no-records-message">{{ 'shared.noRecordsFound' | translate }}</div>
}
